export default __webpack_public_path__ + "static/media/elderly-stroll.db8e90ed.svg";